import React, { useContext, useEffect, useRef, useState } from 'react'

import { CheckCircleOutlined, GiftOutlined, } from '@ant-design/icons';
import { Button, Card, Checkbox, Divider, Form, Input, InputNumber, Select, Typography } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import TextArea from 'antd/es/input/TextArea';

import { apiGetAllAppActivities, apiGetAllAppCampaigns } from '../../../../../helpers/Api';
import MarketingOperationCopyButton from '../../MarketingOperationCopyButton';
import { CreateOperationDataContext } from '../../../../../helpers/Context';
import DiMarketingCouponTour from '../../../../tours/DiMarketingCouponTour';

export default function ChannelCouponForm() {

  const [selectedValueType, setSelectedValueType] = useState("percentage");
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedActivity, setSelectedActivity] = useState("");
  const [expireDays, setExpireDays] = useState(1);
  const [claimDays, setClaimDays] = useState(1);
  
  const [showCreateCouponForm, setShowCreateCouponForm] = useState(true)
  const [haveCondition, sethaveCondition] = useState(true);
  const [haveCosts, sethaveCosts] = useState(false);

  const [loadingActivities, setLoadingActivities] = useState(true);
  const [loadingCampaigns, setLoadingCampaigns] = useState(true);

  const [appActivities, setAppActivities] = useState([]);
  const [appCampaigns, setAppCampaigns] = useState([]);

  const [text, setText] = useState('');

  const textAreaRef = useRef(null);

  const contextValue = useContext(CreateOperationDataContext);

  const { channelsGroupObjLabel, globalContext, form, operationData } = contextValue;
  const { errorNotification, appToken, currency, publicCode, diAppRef } = globalContext; 


  const formPrefix = "COUPON";

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 }, 
      md: { span: 12 },
      lg: { span: 14 },
      xl: { span: 10},
      xxl: { span:8 },
    },
  };
  const formItemOrientation = "horizontal";

  const onChangeExpirationDays = value => {
    setExpireDays(value);
    setClaimDays(value - 1);
    form.validateFields();
  }

    /////////////////////////////////////////////////////////////////////////////////////////// 
            //////////////////// recupero i dati dell' app easyappear ///////////////
   ///////////////////////////////////////////////////////////////////////////////////////////

  
    useEffect(() => {
      if (!appToken) return;

      if (operationData) {
        const couponEntry = operationData.operation_channels.find(obj => obj.COUPON !== undefined);
        sethaveCosts(!couponEntry["COUPON"].isFree);
      }

      const fetchAppCampaigns = async () => {
        try {
          setLoadingCampaigns(true);
          const res = await apiGetAllAppCampaigns(appToken);

          if (!res.message) {
            setAppCampaigns(res);
          } else {
            console.log(res);
          }
        } catch (error) {
          console.error(error);
          errorNotification(error);
        } finally {
          setLoadingCampaigns(false);
        }
      };
      const fetchAppActivities = async () => {
        try {
          setLoadingActivities(true);
          const res = await apiGetAllAppActivities(appToken);

          if (!res.message) {
            setAppActivities(res);
          } else {
            console.log(res);
          }
        } catch (error) {
          console.error(error);
          errorNotification(error);
        } finally {
          setLoadingActivities(false);
        }
      };

      fetchAppActivities();
      fetchAppCampaigns();
    }, [appToken]);
  
  useEffect(() => {
    form.validateFields();
  },[haveCosts])

  return (
    <>
      
      {/* <Card className='bg-dark-02 mb-20'>
        <Typography className="fs-16 bold mb-20">
           <GiftOutlined /> Seleziona Coupon
        </Typography>

        {<Form.Item
          {...formItemLayout} 
          name={[channelsGroupObjLabel, formPrefix, "coupon_id"]}
          key={[channelsGroupObjLabel, formPrefix, "coupon_id"]}
          label={
            <div>
              <Typography>Coupon (DylogApp)</Typography>
            </div>
          }
          layout={formItemOrientation}
          rules={[
            {
              required: true,
              message: "Seleziona il coupon da inviare ai clienti",
            },
          ]}
        >
          <Select
            onChange={(value, option) => {
              if (option) {
                setSelectedCoupon(option.label); // salva la label selezionata
              } else {
                setSelectedCoupon(null); // reset se viene pulito
              }
            }}
            loading={loading}
            placeholder="Seleziona il coupon"
            allowClear
            options={appCoupons}
          />
        </Form.Item>

        <div className='w-100 flex justify-end'>
          <div className='flex flex-wrap gap-10 align-center justify-center mt-10'>
            <Typography>Non hai ancora il coupon che desideri?</Typography>
            <Button type='primary' onClick={()=>setShowCreateCouponForm(!showCreateCouponForm)}> + Crea Coupon</Button>
          </div>
        </div>}

      </Card> */}
  
      

        {/* ---------------- campo nascosto per passare anche il token app e public code ---------------- */}
        <Form.Item
          {...formItemLayout} 
          name={[channelsGroupObjLabel, formPrefix, "token_key"]}
          key={[channelsGroupObjLabel, formPrefix, "token_key"]}
          layout={formItemOrientation}
          initialValue={appToken}
          hidden
        >
          <Input/>
        </Form.Item>
        <Form.Item
          {...formItemLayout} 
          name={[channelsGroupObjLabel, formPrefix, "public_code"]}
          key={[channelsGroupObjLabel, formPrefix, "public_code"]}
          layout={formItemOrientation}
          initialValue={publicCode}
          hidden
        >
          <Input/>
        </Form.Item>
        {/* ---------------- campo nascosto per passare anche il token app e public code ---------------- */}

      
      {showCreateCouponForm &&
        <Card className='bg-dark-02' ref={diAppRef.refOperationsCouponArea}>
          
        <div className='w-100 mb-10 text-right'>
          <DiMarketingCouponTour context={globalContext}/>
        </div>
  
        <Typography className="fs-16 bold mb-20">
           <GiftOutlined /> Dati del Coupon
        </Typography>
          
        <div  ref={diAppRef.refOperationsCouponTitle}>
          <Form.Item
            {...formItemLayout} 
            layout='horizontal'
            name={[channelsGroupObjLabel, formPrefix, "title"]}
            label={
              <div className="flex gap-5">
                <MarketingOperationCopyButton
                  fieldName={[channelsGroupObjLabel, formPrefix, "title"]}
                />
                Nome
              </div>
            }
            rules={[
              {
                required: true,
                message: "Per favore, inserisci il nome del Coupon!",
              },
            ]}
          >
            <Input/>
          </Form.Item>
        </div>
          
        {/* <Form.Item
          {...formItemLayout}
          layout={formItemOrientation}
          name={[channelsGroupObjLabel, formPrefix, "code"]}
          label={"Codice Coupon"}
          rules={[
            {
              required: true,
              message: "Il campo riferimento è obbligatorio per il Coupon",
            },
          ]}
        >
          <Input/>
        </Form.Item> */}
          
        <div ref={diAppRef.refOperationsCouponSubtitle}>
          <Form.Item
            {...formItemLayout} 
            layout={formItemOrientation}
            name={[channelsGroupObjLabel, formPrefix, "subtitle"]}
            initialValue={""}
            label={
              <div className="flex gap-5">
                <MarketingOperationCopyButton
                  fieldName={[channelsGroupObjLabel, formPrefix, "subtitle"]}
                />
                Descrizione Breve
              </div>
            }
          >
            <Input allowClear/>
          </Form.Item>
        </div>
          
        <div ref={diAppRef.refOperationsCouponDescription}>
          <Form.Item
            {...formItemLayout} 
            layout={formItemOrientation}
            name={[channelsGroupObjLabel, formPrefix, "body"]}
            initialValue={""}
            label={
              <div className="flex gap-5">
                <MarketingOperationCopyButton
                  fieldName={[channelsGroupObjLabel, formPrefix, "body"]}
                />
                Descrizione Completa
              </div>
            }
          >
             <TextArea
                ref={textAreaRef} // Riferimento alla TextArea
                maxLength={80}
                value={text}
                showCount
                allowClear
             />
          </Form.Item>
        </div>
          
        {/* <Form.Item
          {...formItemLayout} 
          name={[channelsGroupObjLabel, formPrefix, "file"]}
          label={"Copertina"}
          valuePropName={"fileList"}
          layout={formItemOrientation}
          getValueFromEvent={(e) => e?.fileList}
        >
          <MarketingUploadFile context={contextValue} fieldName={[channelsGroupObjLabel, formPrefix]} />
        </Form.Item> */}
  
        <Divider>Valore</Divider>
        
        <div ref={diAppRef.refOperationsCouponType}>
          <Form.Item
            {...formItemLayout} 
            name={[channelsGroupObjLabel, formPrefix, "type"]}
            key={[channelsGroupObjLabel, formPrefix, "type"]}
            label="Tipologia"
            layout={formItemOrientation}
            initialValue={"percentage"}
          >
              <Select
                onChange={(e)=>{setSelectedValueType(e)}}
                placeholder="Seleziona la tipologia"
                allowClear
                options={[
                  { value: "percentage", label: "Percentuale" },
                  { value: "currency", label: `Importo` },
                  // { value: "offer", label: "Offerta" },
                ]}
              />
          </Form.Item>
        </div>
        
        <div ref={diAppRef.refOperationsCouponValue}>
          <Form.Item
            {...formItemLayout} 
            layout={formItemOrientation}
            label={"Valore Coupon"}
            name={[channelsGroupObjLabel, formPrefix, "value"]}
            key={[channelsGroupObjLabel, formPrefix, "value"]}
            rules={[
              {
                required: true,
                message: "Il valore è obbligatorio per il Coupon",
              },
            ]}
          >
              <InputNumber max={selectedValueType === "percentage" ? 100 : null } className='min-w-150' suffix={selectedValueType === "percentage" ? "%  di sconto" : `${currency} di sconto` } />
          </Form.Item>
        </div>
        
        <Divider>Condizioni</Divider>
      {/*   
         <Form.Item
            name={[channelsGroupObjLabel, formPrefix, "is_obtained"]}
            valuePropName="checked"
            onChange={()=>sethaveCondition(!haveCondition)}
          >
            <Checkbox>Il Coupon ha delle condizioni</Checkbox>
        </Form.Item> */}
  
        {haveCondition &&
         <>
          
            <div ref={diAppRef.refOperationsCouponExpirationDays}>
              <FormItem
                {...formItemLayout} 
                layout={formItemOrientation}
                name={[channelsGroupObjLabel, formPrefix, "couponExpiration"]}
                label={<span className='pt-5'>Entro quanti giorni si può usare? <Typography className='fs-12 opacity-08'>da quando il cliente otterrà il coupon</Typography></span>}
                rules={[
                  {
                    required: true,
                    message: "Definisci i giorni per utilizzare il coupon",
                  },
                ]}
              >
                {/* <DatePicker
                  className='mobile-w-100'
                  format={dateHourFormat}
                  placeholder='Seleziona la scadenza'
                /> */}
                <InputNumber min={1} onChange={onChangeExpirationDays}/>
              </FormItem>
            </div>
          
            <div ref={diAppRef.refOperationsCouponCustomerUsage}>
              <Form.Item
                {...formItemLayout} 
                layout={formItemOrientation}
                label={"Utilizzi per cliente"}
                name={[channelsGroupObjLabel, formPrefix, "customer_availability"]}
                key={[channelsGroupObjLabel, formPrefix, "customer_availability"]}
                initialValue={1}
                rules={[
                  {
                    required: true,
                    message: "Utilizzi per cliente è obbligatorio",
                  },
                ]}
              >
                <InputNumber min={1}/>
              </Form.Item>
            </div>
          
            <div ref={diAppRef.refOperationsCouponMaxUsage}>
              <Form.Item
                {...formItemLayout} 
                layout={formItemOrientation}
                label={<span>Utilizzi massimi totali <Typography className='fs-12 opacity-08'>0 equivarrà ad infinito</Typography></span>}
                initialValue={0}
                name={[channelsGroupObjLabel, formPrefix, "maximum_availability"]}
                key={[channelsGroupObjLabel, formPrefix, "maximum_availability"]}
              >
                <InputNumber/>
              </Form.Item>
           </div>
          
          <div ref={diAppRef.refOperationsCouponMinAmountCart}>
            <Form.Item
              {...formItemLayout} 
              layout={formItemOrientation}
              label={"Importo minimo di spesa per usarlo"}
              name={[channelsGroupObjLabel, formPrefix, "minimum_amount"]}
              key={[channelsGroupObjLabel, formPrefix, "minimum_amount"]}
              initialValue={0}
            >
              <InputNumber className='min-w-150' min={0} suffix={currency} />
            </Form.Item>
          </div>
          
            
            {/* <Form.Item
              {...formItemLayout} 
              layout={formItemOrientation}
              name={[channelsGroupObjLabel, formPrefix, "hide"]}
              valuePropName="checked"
              label="Nascondi coupon nella lista"
            >
              <Checkbox>Nascondi coupon</Checkbox>
            </Form.Item> */}
          
         </>
        }
  
        <Divider>Valore per ottenimento</Divider>
        
        <div ref={diAppRef.refOperationsCouponIsFree}>
          <Form.Item
            name={[channelsGroupObjLabel, formPrefix, "isFree"]}
            valuePropName="checked"
            getValueFromEvent={(e) => e.target.checked}
            // onChange={() => {
            //   sethaveCosts(!haveCosts)
            // }}
            initialValue={!haveCosts}
          >
              <Checkbox disabled>Il coupon è gratuito <Typography className='fs-12 opacity-08'>il cliente lo troverà già nei suoi coupon pronto da usare</Typography></Checkbox>
          </Form.Item>
        </div>
  
        {haveCosts &&
            <div className='di-card bg-dark-02' >
              <Typography className='mb-20 opacity-08'>Se il coupon non è gratuito, definisci il costo per ottenerlo ed entro quanti giorni può farlo</Typography>
              

            <div ref={diAppRef.refOperationsCouponClaimDays}>
              <FormItem
                {...formItemLayout} 
                layout={formItemOrientation}
                name={[channelsGroupObjLabel, formPrefix, "claimWindow"]}
                label="Entro quanti giorni può ottenerlo?"
                rules={[
                  {
                    required: true,
                    message: "Definisci i giorni per ottenere il coupon",
                  },
                  {
                    validator(_, value) {
                      if (value < expireDays) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(`Il valore deve essere minore dei giorni per usare il coupon (${expireDays})`)
                      );
                    },
                  },
                ]}
                initialValue={1}
              >
                <InputNumber min={1} max={claimDays}/>
              </FormItem>
            </div>
              
          <div ref={diAppRef.refOperationsCouponCampaignData}>
            <Form.Item
              {...formItemLayout} 
              name={[channelsGroupObjLabel, formPrefix, "campaign_reference"]}
              key={[channelsGroupObjLabel, formPrefix, "campaign_reference"]}
              layout={formItemOrientation}
              label="Campagna"
              rules={[
                {
                  required: true,
                  message: "Se il coupon non è gratuito, va scelta la campagna",
                },
              ]}
            >
                <Select
                  onChange={(e)=>setSelectedCampaign(e)}
                  placeholder="Seleziona la tipologia"
                  loading={loadingCampaigns}
                  options={appCampaigns}
                  allowClear
                />
            </Form.Item>
          </div>
          
            {selectedCampaign &&
              <Form.Item
                {...formItemLayout} 
                name={[channelsGroupObjLabel, formPrefix, "activity_reference"]}
                key={[channelsGroupObjLabel, formPrefix, "activity_reference"]}
                layout={formItemOrientation}
                label="Attività"
                rules={[
                  {
                    required: true,
                    message: "Se il coupon non è gratuito, scegli l'attività",
                  },
                ]}
              >
                  <Select
                    onChange={(e, obj)=>setSelectedActivity(obj.label)}
                    placeholder="Seleziona la tipologia"
                    loading={loadingActivities}
                    options={appActivities}
                    allowClear
                  />
              </Form.Item>
            }

            {selectedActivity &&
              <Form.Item
                {...formItemLayout} 
                layout={formItemOrientation}
                label={`Importo in ${selectedActivity} per ottenerlo`}
                name={[channelsGroupObjLabel, formPrefix, "loyalty_type_amount"]}
                key={[channelsGroupObjLabel, formPrefix, "loyalty_type_amount"]}
                rules={[
                  {
                    required: true,
                    message: "Se il coupon non è gratuito, scegli la cifra per ottenerlo",
                  },
                ]}
              >
                <InputNumber min={1}/>
              </Form.Item>
            }
          </div>
        }
        
          
        </Card>
      }
  
      
    </>
  );
}
